import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../navigators/NavigationProp';

import Index, {
  DispatchProps,
  StateProps,
} from '../../../components/shop/actors/Index';

import AppState from '../../../reducers/AppState';

import indexActorCategories, {
  Params as ActorCategoryIndexParams,
} from '../../../actions/actor_categories/index';
import indexActors, {
  Params as ActorIndexParams,
} from '../../../actions/actors/index';
import selectEntities, {getTotalCount} from '../../../helpers/selectEntities';
import selectEntity from '../../../helpers/selectEntity';
import {ShopActorsRouteProp} from '../../../navigators/RouteProps';

import buildActorSearchParams from '../../../view_models/buildActorSearchParams';

interface Props {
  navigation: NavigationProp;
  route: ShopActorsRouteProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation, route} = props;
  const {entities, queries, writerCurrentUserId} = state;
  const {formValues, sort, page} = route.params || {};
  const currentUser = writerCurrentUserId
    ? selectEntity(entities.writer.currentUsers, writerCurrentUserId)
    : null;
  const currentUserStatus = currentUser
    ? selectEntity(
        entities.writer.currentUserStatuses,
        currentUser.writerUserId,
      )
    : null;
  const actorsParams: ActorIndexParams = {
    ...buildActorSearchParams(
      formValues || {
        query: '',
        ageMin: 0,
        ageMax: 6,
        rootCategoryIdToActorCategoryIds: [],
        favorite: false,
      },
    ),
    paid: true,
    page,
    sort: sort || 'new_arrival',
  };
  const actors = selectEntities(entities.actors, queries.actors, actorsParams);
  const totalCount = getTotalCount(queries.actors, actorsParams);
  const actorCategoriesParams: ActorCategoryIndexParams = {};
  const actorCategories = selectEntities(
    entities.actorCategories,
    queries.actorCategories,
    actorCategoriesParams,
  );
  const actorQueries = queries.actors;
  return {
    navigation,
    currentUser,
    currentUserStatus,
    actors,
    actorsParams,
    actorCategories,
    actorCategoriesParams,
    actorQueries,
    totalCount,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    indexActorCategories: (params: ActorCategoryIndexParams) =>
      dispatch(indexActorCategories(params)),
    indexActors: (params: ActorIndexParams) => dispatch(indexActors(params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(Index);
